// Imports
import { doRequest } from "../../modules/request";
import { forceInt } from "../../utils/forceInt";
import { getUser, getPhone, getName } from "../../utils/getPreTickets";
import { recuperaApostasAPI } from "../relatorios/suasapostasActions";
import { restartSession } from "../usuario/usuarioActions";

export const APOSTA_ADDED = "APOSTA_ADDED";
export const APOSTA_REMOVED = "APOSTA_REMOVED";
export const REQUEST_APOSTA_CARRINHO = "REQUEST_APOSTA_CARRINHO";
export const RECEIVE_APOSTA_CARRINHO = "RECEIVE_APOSTA_CARRINHO";
export const RECEIVE_ETICKET = "RECEIVE_ETICKET";
export const ERROR_ETICKET = "ERROR_ETICKET";
export const ETICKET_REMOVED = "ETICKET_REMOVED";

export function addAposta(aposta) {
  return {
    type: APOSTA_ADDED,
    payload: aposta,
  };
}

export function removeAposta(Aposta_id) {
  return {
    type: APOSTA_REMOVED,
    payload: Aposta_id,
  };
}

export const requestApostaCarrinho = () => ({
  type: REQUEST_APOSTA_CARRINHO,
});

export const receiveApostaCarrinho = () => ({
  type: RECEIVE_APOSTA_CARRINHO,
});

export const receiveETicket = (payload) => ({
  type: RECEIVE_ETICKET,
  payload: payload,
});

export const erroReceiveETicket = (payload) => ({
  type: ERROR_ETICKET,
  payload: payload,
});

export function removeETicket(vchETicket) {
  return {
    type: ETICKET_REMOVED,
    payload: vchETicket,
  };
}

export const enviarAposta = (eTicket, callback, isPreTicket = false, isPix = false, errorCallback) => (dispatch, getState) => {
  const session = window["wweb-session"];

  dispatch(requestApostaCarrinho());

  if (isPix && !isPreTicket) {
    const arrMeioPagamento = session.arrMeioPagamento || [];
    const pagamentoPix = arrMeioPagamento.find((pagamento) => pagamento.vchFormaPagamento === "PIX") || {};

    eTicket.tnyMeioPagamentoTransacao = pagamentoPix.tnyFormaPagamento;
    eTicket.bitPreValidacao = true;
  }

  const params = {
    url: isPreTicket ? "/PreTicket" : "/Transaction",
    method: "POST",
    data: { ...eTicket, isJBWeb: true, vchLoginWeb: getUser(), vchTelefone: getPhone(), vchNomeCliente: getName() },
  };

  const runAttempt = (numAttempts = 0) => doRequest(params)
    .then((response) => {
      let vchETicket = undefined;

      if (response.intCodigoRetorno > 0 || response.isError) {
        if (response.strErrorMessage.toLowerCase().includes("realize log")) {
          if (numAttempts < 1) {
            const session = window["wweb-session"];
            restartSession(session.Cliente_ID, session.LoginLE, session.TokenLE, session.SessionIDLE).then(() => {
              runAttempt(numAttempts + 1);
            });
            return;
          }
        }

        if (errorCallback) errorCallback("Erro", response.strErrorMessage);
        dispatch(erroReceiveETicket(response.strErrorMessage));
        dispatch(receiveApostaCarrinho());
      } else {
        let tickets = getState().carrinho.eTickets;

        response.detail = eTicket;
        tickets.push(response);

        vchETicket = response;
        vchETicket.timestamp = Date.now();

        dispatch(receiveETicket(tickets));

        if (isPix && !isPreTicket) {
          const ticket = {
            ...vchETicket,
            detail: eTicket,
            qrCode: response.vchUrlQrCodePagamento,
            chrCodigoPonto: eTicket.chrCodigoPonto,
            chrCodigoOperador: eTicket.chrCodigoOperador,
            Cliente_ID: eTicket.Cliente_ID,
            Site_ID: forceInt(eTicket.Site_ID),
            GUID: response.vchGuidPreValidacao,
            mensagem: response.mensagem,
            isError: response.isError,
            paid: false
          }

          dispatch(receiveApostaCarrinho());
          callback(ticket, isPreTicket, isPix);
        } else {
          dispatch(receiveApostaCarrinho());
          callback(vchETicket, isPreTicket, isPix);
        }
      }
    })
    .catch((error) => {
      console.error(error);
      if (errorCallback) errorCallback("Falha ao enviar transação.", error.message);
      dispatch(receiveApostaCarrinho());
      dispatch(erroReceiveETicket(error.message));
      callback(undefined, isPreTicket, isPix);
    });

  return runAttempt();
};

export const verificaPagamentoPix = (eTicket, callback, payload = {}) => {
  const params = {
    url: "/VerificaStatusPreValidacao",
    method: "POST",
    data: {
      Cliente_ID: eTicket.Cliente_ID,
      Site_ID: forceInt(eTicket.Site_ID),
      CID: eTicket.CID,
      Banca_ID: eTicket.Cliente_ID,
      chrSerial: eTicket.chrSerial,
      Session_ID: eTicket.Session_ID,
      strToken: eTicket.strToken,
      vchGuidPreValidacao: eTicket.GUID,
      ...payload
    },
  };

  return doRequest(params)
    .then((resStatus) => {
      if (resStatus.tnyStatusPagamento == 1 && resStatus.tnyStatusPreValidacao == 2) {
        const objUser = {
          Cliente_ID: eTicket.Cliente_ID,
          Site_ID: forceInt(eTicket.Site_ID),
          CID: eTicket.CID,
          Session_ID: eTicket.Session_ID,
        };

        for (let i = 0; i < resStatus.RetornoJogo.arrETicket.length; i++) {
          const objAposta = {
            intNumeroPule: resStatus.RetornoJogo.arrIntNumeroPule[i],
            chrSerial: eTicket.chrSerial,
            vchETicket: resStatus.RetornoJogo.arrETicket[i],
            vchGuidPreValidacao: eTicket.GUID
          };

          recuperaApostasAPI(objUser, objAposta, (resBetDetail) => {
            const hasNumeroPule = resBetDetail && resBetDetail.arrJogo && resBetDetail.arrJogo[i];
            const hasCodigoSeguranca = resBetDetail && resBetDetail.arrJogo && resBetDetail.arrJogo[i];
            const hasVchETicket = resBetDetail && resBetDetail.arrJogo && resBetDetail.arrJogo[i];

            const newTicket = {
              ...resStatus,
              arrJogo: resBetDetail.arrJogo,
              ticketAmount: resStatus.RetornoJogo.arrETicket.length,
              intNumeroPule: hasNumeroPule ? resBetDetail.arrJogo[i].intNumeroPule : resStatus.intNumeroPule,
              vchETicket: hasVchETicket ? resBetDetail.arrJogo[i].vchETicket : resStatus.vchETicket,
              vchCodigoSeguranca: hasCodigoSeguranca ? resBetDetail.arrJogo[i].vchCodigoSeguranca : "",
              chrSerial: params.data.chrSerial,
              detail: { ...resBetDetail, vchETicket: resStatus.RetornoJogo.arrETicket[i] },
              numPremioTotal: resBetDetail.numPremioTotal,
              numValorPremioCotaTotal: resBetDetail.numValorPremioCotaTotal
            };

            if (newTicket && (!newTicket.bets || !newTicket.bets.length)) {
              const cart = (resBetDetail && resBetDetail.arrJogo) ?
                resBetDetail.arrJogo.map((jogo) => ({
                  amount: 1,
                  number: jogo.vchNumero,
                  value: jogo.numValorTotal || jogo.valorTotal,
                })) : [];

              newTicket.bets = cart;
            }

            if (callback) callback(newTicket);
          });
        }
      } else {
        if (callback) callback({ ...resStatus, detail: {} });
      }
    })
    .catch((error) => {
      throw new Error(error);
    });
};


// WEBPACK FOOTER //
// ./src/reducers/carrinho/carrinhoActions.js